module.exports = "/assets/31d462845dd7a98955c81f94e6e1019a.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/AI.png
// module id = 2325
// module chunks = 0